@if (fixedSchedule()) {
  <vdw-ellipsis-label class="order-name font-weight-semibold b1" [text]="name()" matTooltipPosition="above"></vdw-ellipsis-label>
}
